import MyModal from "../../../Common/my-modal/my-modal.component";
import FormComponent from "./form.component";
import ExtendTrialFormWrapper from "./form-wrapper";

interface ModalFormProps {
  onClose: () => void;
  onConfirm: (values: { days: string; reason: string }) => void;
  loading: boolean;
  isSendRequestView?: boolean;
}

const ModalForm = ({ onClose, onConfirm, loading, isSendRequestView = true }: ModalFormProps) => {
  const handleSubmit = (values: { days: string; reason: string }) => {
    onConfirm(values);
  };

  return (
    <ExtendTrialFormWrapper onSubmit={handleSubmit}>
      {(formikProps) => (
        <div>
          <MyModal.Body className="p-0">
            <FormComponent formikProps={formikProps} isSendRequestView={isSendRequestView}/>
          </MyModal.Body>

          <MyModal.Footer className="d-flex gap-8 justify-content-end">
            <MyModal.CancelButton onClick={onClose}>
              Cancel
            </MyModal.CancelButton>

            <MyModal.ApplyButton
              onClick={() => formikProps.handleSubmit()}
              loading={loading}
              disabled={!formikProps.isValid || formikProps.isSubmitting}
            >
              {isSendRequestView ? "Confirm" : "Send"}
            </MyModal.ApplyButton>
          </MyModal.Footer>
        </div>
      )}
    </ExtendTrialFormWrapper>
  );
};

export default ModalForm;
